<template>
  <div class="wrapper">
    <div class="tech-dropdown">
      <div class="tech-dropdown-toggle">
        <a href="javascript:void(0);" @click="ddToggle">
          <i class="material-icons-outlined align-middle">more_horiz</i>
        </a>
      </div>
      <div class="tech-dropdown-menu" v-show="params.data.ddOpen">
        <ul>
          <li>
            <a href="javascript:void(0);" @click="sendSingle">
              <i class="material-icons align-middle">send</i>
              Send
            </a>
          </li>
          <li>
            <a href="javascript:void(0);" @click="viewAs">
              <i class="material-icons align-middle">visibility</i>
              View As
            </a>
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>

<script>
import { getOnlyDocDataQuery } from "@/vendor/database";

export default {
  computed: {
    isOpen() {
      return this.params.data.ddOpen;
    },
  },
  watch: {
    isOpen: function (val) {
      if (val) {
        let offset = this.$el.getBoundingClientRect();
        if (document.body.clientHeight - offset.top < 230) {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "auto";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "37px";
        } else {
          this.$el.querySelector(".tech-dropdown-menu").style.top = "40px";
          this.$el.querySelector(".tech-dropdown-menu").style.bottom = "auto";
        }
      }
    },
  },
  methods: {
    ddToggle: function () {
      this.params.data.ddOpen = !this.params.data.ddOpen;
      this.params.context.componentParent.openCurrentAgDropdown(
        this.params.data,
        this.$el
      );
    },
    sendSingle: function () {
      this.ddToggle();
      this.params.context.componentParent.sendSingle(this.params.data);
    },
    viewAs: async function () {
      this.ddToggle();
      const result = await getOnlyDocDataQuery(
        "consultants",
        "email",
        this.params.data.email
      );
      if (result.ok) {
        const consultant = result.data;
        this.$store.commit("setTechSlackId", consultant.data.slack_id);
        this.$store.commit("setTechUserId", consultant.id);
        this.$store.commit("setTechUserName", consultant.data.name);
        this.$store.commit("setViewingAs", {
          role: "consultant",
          email: consultant.data.email,
          name: consultant.data.name,
          slackId: consultant.data.slack_id,
          id: consultant.id,
          photoURL: consultant.data.photo_url,
          path: this.$router.currentRoute.path,
        });
        this.$router.push({
          path: "/home/consultant/consultant_dashboard",
          query: { id: consultant.id },
        });
      }
    },
  },
};
</script>

<style scoped>
.wrapper {
  height: 68px;
  display: flex;
  align-items: center;
}
</style>
